module.exports = __webpack_public_path__ + "r-v3/img/ml_20_00_over.b5f588b8.jpg";